// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="'Cashier cash shortage'"></sub-header>

    <h2 class="section-header">Please confirm the following:</h2>
    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table">
        <tbody>
          <tr>
            <td>1.</td>
            <td>Amount of shortage:</td>
            <td>
              <cash ng-model="\$ctrl.transaction.amount"
                    ng-required="true"
                    min="0.01">
              </cash>
            </td>
          </tr>
          <tr>
            <td>2.</td>
            <td>Remarks:</td>
            <td>
              <input
                type="text"
                maxlength="512"
                ng-model="\$ctrl.transaction.remarks"
                required/>
            </td>
          </tr>
        </tbody>
      </table>

      <denomination
        group="'OUTGOING'"
        object-ref="\$ctrl.transaction"
        total-value-ref="\$ctrl.transaction.amount"
        currency-iso-code="PHP"
        one-sided="true">
      </denomination>

      <div class="buttons">
        <button
          class="misc-transaction__cancel btn btn-warning"
          ng-disabled="\$ctrl.transactionForm.\$pristine"
          ng-click="\$ctrl.cancelChanges()">
          Cancel
        </button>
        <button
          type="submit"
          class="misc-transaction__save btn btn-danger"
          ng-disabled="\$ctrl.transactionForm.\$invalid || !\$ctrl.denominationIsValid()"
          ng-click="\$ctrl.save()">
          Shortage
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/cashier-cash-shortage/cashier-cash-shortage.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;